/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  height: 100%;
  max-width: 100%;
  display: flex;
  padding: 6px 0px 4px 0px;
  button {
    visibility: hidden;
  }
  text-align: left;
`;

export const IconBox = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
`;

export const TextBox = styled.div`
  height: 100%;
  width: 100%;
`;

export const Text = styled.div`
  max-width: 275px;
  :hover {
    cursor: pointer;
  }
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  ${({ isDeleted }) => {
    switch (isDeleted) {
      case true:
        return css`
          color: ${Palette.PrimaryGray._500};
        `;
      case false:
        return css`
          color: ${Palette.PrimaryGray._700};
          :hover {
            color: ${Palette.Primary._600};
          }
        `;
    }
  }}
`;

export const NameContainer = styled.div`
  display: flex;
  width: 95%;
`;

export const AppIdWrap = styled.div`
  width: 100%;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${Palette.PrimaryGray._500};
  margin-bottom: 2px;
`;

export const AppId = styled.span`
  display: inline-block;
  width: 70%;
  color: ${Palette.PrimaryGray._700};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
`;
